/* Copyright (c) 2022 MOCA Systems, Inc. All rights reserved. */

import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { cssVar } from '@touchplan/css-var';
import {
	ILocationDialogData,
	ProjectLocationDialogComponent,
} from './components/project-location-dialog/project-location-dialog.component';
import {
	IProjectMemberDialogData,
	ProjectMemberDialogComponent,
} from './components/project-member-dialog/project-member-dialog.component';
import {
	IRoleDialogData,
	ProjectRoleDialogComponent,
} from './components/project-role-dialog/project-role-dialog.component';

@Injectable({ providedIn: 'root' })
export class ProjectDialogLauncher {
	constructor(private dialog: MatDialog) {}

	public openMemberDialog(data: IProjectMemberDialogData): void {
		this.dialog.open(ProjectMemberDialogComponent, this.getDialogConfig(data, cssVar.membersDialogWidth));
	}

	public openRoleDialog(data: IRoleDialogData): void {
		this.dialog.open(ProjectRoleDialogComponent, this.getDialogConfig(data, cssVar.rolesDialogWidth));
	}

	public openLocationDialog(data: ILocationDialogData): void {
		this.dialog.open(ProjectLocationDialogComponent, this.getDialogConfig(data, cssVar.locationsDialogWidth));
	}

	private getDialogConfig<T>(data: T, width = null, height = null): MatDialogConfig<T> {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.disableClose = true;
		dialogConfig.width = width;
		dialogConfig.height = null;
		dialogConfig.autoFocus = true;
		dialogConfig.data = data;

		return dialogConfig;
	}
}
